import FormBaseModel from '@cp-models/FormBaseModel';

export default class Profile extends FormBaseModel {
    casts()
    {
        return {
            'id': 'number',
            'name': 'string'
        }
    }

}
